/**
 * Builds numbered TOC metadata from an ordered section definition list.
 * Anchor ids are always `toc-${id}`.
 */
export const buildSectionMeta = (definitions = []) => {
    let major = 0;

    return definitions.map((definition) => {
        const anchorId = `toc-${definition.id}`;
        let number = null;
        let childrenMeta = [];

        if (definition.numbered !== false) {
            major += 1;
            number = String(major);

            childrenMeta = (definition.children || []).map((child, index) => ({
                ...child,
                number: `${major}.${index + 1}.`,
                anchorId: `toc-${child.id}`,
            }));
        } else {
            childrenMeta = (definition.children || []).map((child) => ({
                ...child,
                number: null,
                anchorId: `toc-${child.id}`,
            }));
        }

        const childLookup = childrenMeta.reduce((acc, child) => {
            acc[child.id] = child;
            return acc;
        }, {});

        return {
            ...definition,
            number,
            anchorId,
            children: childrenMeta,
            child: childLookup,
        };
    });
};

export const buildTocEntries = (sectionMeta = []) =>
    sectionMeta.map((section) => ({
        title: section.title,
        number: section.number || undefined,
        anchorId: section.anchorId,
        children: (section.children || []).map((child) => ({
            title: child.title,
            number: child.number || undefined,
            anchorId: child.anchorId,
        })),
    }));

/**
 * Apply runtime children resolvers (e.g. KYB provider reports) before numbering.
 */
export const resolveSectionDefinitions = (definitions = [], context = {}) =>
    definitions.map((definition) => {
        if (typeof definition.resolveChildren !== "function") {
            return definition;
        }

        return {
            ...definition,
            children: definition.resolveChildren(context) || [],
        };
    });
